import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApi } from '../RestApi/restApi';
import { NgxUiLoaderService } from 'ngx-ui-loader';

interface quickshghtref {
  embededUrl:String
}
interface reportingInstance{
  message: any,
  error: boolean,
  data: any,
  statusMessage:any

}
@Injectable({
  providedIn: 'root'
})
export class QuickshghtService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private Http: HttpClient, private rest: RestApi) { }

  geturl() {
    return this.Http.get<quickshghtref>(this.rest.RETRIEVE_QUICKSIGHT, { headers: this.headers })
  }

  getAnalysis(analysis) {
    return this.Http.get<quickshghtref>(this.rest.RETRIEVE_ANALYSIS+"/"+analysis, { headers: this.headers })
  }

  retrieveanalysis(analysisid){
    return this.Http.get<quickshghtref>(this.rest.RETRIEVE_ANALYSISBYID+"/"+analysisid, { headers: this.headers })
  }

  converToPdf(instanceData){
    return this.Http.post<reportingInstance>(this.rest.INSERT_REPORTINSTANCEFROMQUICKSIGHT,JSON.stringify(instanceData), { headers: this.headers })
  }

  getDashboardUrl() {
    return this.Http.get<quickshghtref>(this.rest.RETRIEVE_QUICKSIGHT_DASHBOARD+"/"+"a14d24aa-112a-4bff-8366-0ffcf19ed68e", { headers: this.headers })
  }

}
